import React from 'react';
import { useSelector } from 'react-redux';
import { ApplicationState } from '../../../../store';
import RefuseSelect from '../RefuseSelect';
import './styles.scss';
const VehicleData: React.FC = () => {
  const { driver, vehicleType } = useSelector(
    (state: ApplicationState) => state,
  );
  return (
    <div style={{ display: 'flex' }}>
      <div className="vehicle-data-contanier">
        <h6>Modelo</h6>
        <p>{driver.vehicle?.model ? driver.vehicle?.model : 'Não informado'}</p>
        <h6>Ano</h6>
        <p>{driver.vehicle?.year ? driver.vehicle?.year : 'Não informado'}</p>
        <h6>Placa</h6>
        <p>{driver.vehicle?.plate ? driver.vehicle?.plate : 'Não informado'}</p>
        <h6>Peso</h6>
        <p>
          {driver.vehicle?.weight
            ? driver.vehicle?.weight + ' kg'
            : 'Não informado'}
        </p>
        <h6>Capacidade de carga</h6>
        <p>
          {driver.vehicle?.payloadCapacity
            ? driver.vehicle?.payloadCapacity + ' kg'
            : 'Não informado'}
        </p>
        <h6>Comprimento do baú</h6>
        <p>
          {driver.vehicle?.width
            ? driver.vehicle?.width + ' m'
            : 'Não informado'}
        </p>
        <h6>Largura do baú</h6>
        <p>
          {driver.vehicle?.length
            ? driver.vehicle?.length + ' m'
            : 'Não informado'}
        </p>
        <h6>Tipo de veículo</h6>
        <p>
          {vehicleType.vehicleType ? vehicleType.vehicleType : 'Não informado'}
        </p>
      </div>
      <RefuseSelect step={5} />
    </div>
  );
};

export default VehicleData;
